import { mergeDeepSafe, resolveAliases } from '../../../utils';
import {
  ComponentsTheme,
  CoreTheme,
  GeneratedTheme,
  SemanticTheme,
} from '../../types';
import mapComponentsTheme from '../mappers/mapComponentsTheme';
import { ThemeOverrides } from '../types';

type Props = {
  generatedTheme: GeneratedTheme;
  core: CoreTheme;
  semantic: SemanticTheme;
  overrides: Pick<ThemeOverrides, 'components'>;
};

const resolveComponentsTheme = ({
  generatedTheme,
  core,
  semantic,
  overrides,
}: Props): ComponentsTheme => {
  const partiallyResolvedTheme = resolveAliases({
    core: mergeDeepSafe(generatedTheme.core, core),
    semantic: mergeDeepSafe(generatedTheme.semantic, semantic),
    components: generatedTheme.components,
  }) as Pick<GeneratedTheme, 'components'>;

  const mappedComponents = mapComponentsTheme({
    core,
    semantic,
    components: partiallyResolvedTheme.components,
  });

  const components = overrides.components
    ? mergeDeepSafe(
        mappedComponents,
        overrides.components({ core, semantic, components: mappedComponents }),
      )
    : mappedComponents;

  return components;
};

export default resolveComponentsTheme;
